/* global $ */
import {
  either,
  equals,
  has,
  propSatisfies,
  when,
  map,
  filter,
  join,
  compose,
  composeX,
  nthArg
} from "$json/lib/functional.js";

let jumplist = [];

$(document).on(
  "bb:preHandleData",
  composeX(
    when(has("jumplist"), ({ jumplist: j }) => {
      jumplist = j;
    }),
    nthArg(1)
  )
);

export const formatJumplist = compose(
  join(" => "),
  map(
    ({ name, screentitle, graph = "" }) =>
      `${graph}${graph ? "." : ""}${name} (${screentitle})`
  ),
  filter(propSatisfies(either(equals("past"), equals("selected")), "status"))
);

export const jumplistArg = () => formatJumplist(jumplist);
